


















import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetNursingQualityControlReporList } from "@/api/pdQualityControlManage/pdNursingQualityControlRepor";
@Component({})
export default class PdNursingQualityControlRepor extends AbpBase {
  loading: boolean = false;
  NursingQualityControlReporList: any[] = [];
  NursingQualityControlReporcolumns = [
    {
      title: "  ",
      key: "name"
    },
    {
      title: "上月完成",
      key: "lastMonth"
    },
    {
      title: "本月完成",
      key: "thisMonth"
    },
    {
      title: "下月完成",
      key: "nextMonth"
    }
  ];
  async getData() {
    this.loading = true;
    var res = await GetNursingQualityControlReporList();
    this.NursingQualityControlReporList = res.objects;
    this.loading = false;
  }
  constructor() {
    super();
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdNursingQualityControlRepor/index.vue